import React from 'react';
import { BookOpen, AlertCircle, CheckCircle, Lightbulb, User } from 'lucide-react';

/**
 * SessionContextPreview - Shows key highlights from selected session
 *
 * Displays:
 * - Topics covered (as pills)
 * - Challenges identified
 * - What worked well
 * - Student profile info (if selected)
 */

const SessionContextPreview = ({ data, selectedTypes }) => {
  const { summary, student } = data || {};

  // Don't render if no data types selected
  if (!selectedTypes.summary && !selectedTypes.studentProfile) {
    return (
      <div className="wb-context-preview wb-context-preview-empty">
        <span>Select at least one data type to preview</span>
      </div>
    );
  }

  return (
    <div className="wb-context-preview">
      {/* Topics */}
      {selectedTypes.summary && summary?.topics_covered?.length > 0 && (
        <div className="wb-context-preview-row">
          <div className="wb-context-preview-icon topics">
            <BookOpen />
          </div>
          <div className="wb-context-preview-content">
            <div className="wb-context-preview-pills">
              {summary.topics_covered.slice(0, 4).map((topic, i) => (
                <span key={i} className="wb-context-pill">
                  {topic}
                </span>
              ))}
              {summary.topics_covered.length > 4 && (
                <span className="wb-context-pill wb-context-pill-more">
                  +{summary.topics_covered.length - 4}
                </span>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Challenges */}
      {selectedTypes.summary && summary?.challenges_identified?.length > 0 && (
        <div className="wb-context-preview-row">
          <div className="wb-context-preview-icon challenges">
            <AlertCircle />
          </div>
          <div className="wb-context-preview-content">
            <span className="wb-context-preview-text">
              {summary.challenges_identified[0]}
            </span>
          </div>
        </div>
      )}

      {/* What Worked */}
      {selectedTypes.summary && summary?.what_worked_well?.length > 0 && (
        <div className="wb-context-preview-row">
          <div className="wb-context-preview-icon success">
            <CheckCircle />
          </div>
          <div className="wb-context-preview-content">
            <span className="wb-context-preview-text">
              {summary.what_worked_well[0]}
            </span>
          </div>
        </div>
      )}

      {/* Next Steps */}
      {selectedTypes.summary && summary?.next_steps?.length > 0 && (
        <div className="wb-context-preview-row">
          <div className="wb-context-preview-icon next">
            <Lightbulb />
          </div>
          <div className="wb-context-preview-content">
            <span className="wb-context-preview-text">
              {summary.next_steps[0]}
            </span>
          </div>
        </div>
      )}

      {/* Student Profile */}
      {selectedTypes.studentProfile && student && (
        <div className="wb-context-preview-row wb-context-preview-student">
          <div className="wb-context-preview-icon student">
            <User />
          </div>
          <div className="wb-context-preview-content">
            <div className="wb-context-preview-student-info">
              {student.learning_style && (
                <span className="wb-context-student-tag">
                  {student.learning_style}
                </span>
              )}
              {student.communication_style && (
                <span className="wb-context-student-tag">
                  {student.communication_style}
                </span>
              )}
            </div>
            {student.goals && (
              <span className="wb-context-preview-text wb-context-preview-goals">
                Goal: {student.goals}
              </span>
            )}
          </div>
        </div>
      )}

      {/* Transcript indicator */}
      {selectedTypes.transcript && (
        <div className="wb-context-preview-row wb-context-preview-transcript">
          <div className="wb-context-preview-icon transcript">
            <BookOpen />
          </div>
          <div className="wb-context-preview-content">
            <span className="wb-context-preview-text">
              Full transcript will be included
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default SessionContextPreview;
